import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';


@Component({
  selector: 'usb-room',
  templateUrl: './room.component.html',
  styleUrls: ['./room.component.scss']
})
export class RoomComponent implements OnInit {

  @Input() room: any;
  @Input() select: any[]; // : [0,1,2,3,4,5];
  @Input() index: number;
  @Input() productQty: number;
  @Input() reserveMultiHab: boolean;
  @Output() calculateTotalPrice = new EventEmitter();
  qtySelect = 0;

  constructor() { }

  ngOnInit() { }

  /**
   * La funcion se encarga de evaluar la cantidad que se pide.
   * Se le manda 1 para que los demas select aparezcan con 1 elemento que sera el 0.
   * @param select Recibe el elemento colocado por el usuario al seleccionar la cantidad.
   */
  public selectRoom(select: any, qty: any) {
    if (!this.reserveMultiHab && this.select.some(obj => obj.selectValue > 0) && !(select.selectValue > 0)) {
    }
    select.selectValue = qty;
    this.addRoomToSelect();
  }

  private addRoomToSelect() {
    const productQtyNowSelect = this.productQtyNowSelect(this.select);
    const productQtyLeft = this.productQty - productQtyNowSelect;
    this.select.forEach((obj, index) => {
      obj.selectArray = Array.from(Array(+obj.selectValue + productQtyLeft + 1).keys());
    });
    this.calculateTotalPrice.emit();
  }

  private productQtyNowSelect(select: any[]): number {
    let total = 0;
    select.forEach(obj => total += +obj.selectValue);
    return total;
  }
}
